export const LOWER_CASE = 'lowerCase';
export const UPPER_CASE = 'upperCase';
